export default "__VITE_ASSET__352973ab__"